export default {
    namespaced: true,
    state: {
        data: [],
        error: false,
        loading: false,
        total: 0,
        perPage: 0,
    },
    mutations: {
        setData: (state, data) => (state.data = data),
        setTotal: (state, total) => (state.total = total),
        setPerPage: (state, perPage) => (state.perPage = perPage),
        setError: (state, error) => (state.error = error),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
    },
    actions: {
        operatorFetchLog: ({ commit }, { id, additionalIds, page }) => {
            commit("loadingProcess");
            const systemLogs = ["incomeActions", "withdrawActions"];
            let url;
            if (systemLogs.includes(id)) {
                url = `/admin/accounts/${id}`;
            } else {
                url = `/admin/accounts/${id}/actions`;
            }
            additionalIds = additionalIds || [];
            return axios
                .get(url, { params: { page, additionalIds } })
                .then(res => {
                    commit("removeError");
                    commit("setData", res.data.data);
                    commit("setTotal", res.data.total);
                    commit("setPerPage", res.data.per_page);
                })
                .catch(err => {
                    commit("setError", err.message ?? "Неизвестная ошибка");
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"));
        },
        fetchLog: ({ commit }, data) => {
            commit("loadingProcess");
            return axios
                .get(`/profile/accounts/${data.id}/actions`, { params: { page: data.page, additionalIds: data.additionalIds } })
                .then(res => {
                    commit("removeError");
                    commit("setData", res.data.data);
                    commit("setTotal", res.data.total);
                    commit("setPerPage", res.data.per_page);
                })
                .catch(err => {
                    commit("setError", err.message ?? "Неизвестная ошибка");
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"));
        },
    },
};
